import * as Highcharts from 'highcharts';

import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {CockpitCard} from 'shared/dtos/cockpit-card';
import {Cockpit} from 'shared/dtos/cockpit/cockpit';
import {Lohnverteilung} from 'shared/dtos/cockpit/lohnverteilung';
import {
  GESTAPELT,
  UNGESTAPELT
} from 'shared/EnumsConstants/card-charts-translate-keys.enum';
import {DataStorageService} from 'shared/services/data-storage.service';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';
import {ChartTemplateService} from '../../charts-templates/chart-template.service';
import {CockpitContentComponent} from '../../cockpit-content-component';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';

@Component({
  selector: 'app-lohnverteilung',
  templateUrl: './chart-dialog-lohnverteilung.component.html',
  styleUrl: '../../card/card.component.scss',
  providers: [ChartTemplateService],
  standalone: false
})
export class ChartDialogLohnverteilungComponent
  extends CurrentLocaleComponent
  implements OnInit, AfterViewInit, CockpitContentComponent
{
  card: CockpitCard;
  chart: Highcharts.Chart;
  series: string;
  stacked = false;
  lohnverteilung: Lohnverteilung;
  gestapelt: string = GESTAPELT;
  ungestapelt: string = UNGESTAPELT;
  tableHeaders = [
    'i18n.cockpit.card.chart.lohnverteilung.anzahlMitarbeitendeProViertel'
  ];

  constructor(
    @Inject(ChartTemplateService)
    private readonly chartTemplate: ChartTemplateService,
    private readonly storage: DataStorageService,
    protected readonly translate: TranslateService,
    private readonly tableExport: TableExportService
  ) {
    super(translate);
    this.lohnverteilung = new Lohnverteilung();
    this.chartTemplate.chartname = 'lohnverteilung';
  }

  async ngOnInit() {
    super.ngOnInit();

    this.storage.getCockpitData().then(data => {
      this.lohnverteilung = (data as Cockpit).lohnverteilung;
    });
  }

  ngAfterViewInit(): void {
    this.storage.getChartsData().then(data => {
      this.series = data.lohnverteilung;

      this.initHighCharts(JSON.parse(this.series));
      this.selectionGestapeltUngestepeltChanged({value: this.gestapelt});

      this.translate.onLangChange.subscribe(() => {
        const svgContainer = document.getElementById(
          'svgContainerChartDialogLohnverteilung'
        );
        if (svgContainer) {
          const stack = {value: this.stacked ? GESTAPELT : UNGESTAPELT};
          this.initHighCharts(JSON.parse(this.series));
          this.selectionGestapeltUngestepeltChanged(stack);
        }
      });
    });
  }

  exportChart() {
    this.chart.exportChart(
      {
        type: 'application/pdf',
        filename: 'my-pdf'
      },
      {}
    );
  }

  exportTable() {
    const cardTitle = this.translate.instant(
      'i18n.cockpit.card.Lohnteilung.title'
    );
    this.tableExport.exportHtmlTable(null, cardTitle);
  }

  selectionGestapeltUngestepeltChanged(item) {
    if (!this.chart.series) {
      this.initHighCharts(JSON.parse(this.series));
    }
    this.stacked = item.value === GESTAPELT;
    let plotOptions = {};

    if (this.stacked) {
      plotOptions = {
        plotOptions: {
          series: {stacking: 'normal'}
        }
      };
    } else {
      plotOptions = {
        plotOptions: {
          series: {stacking: ''}
        }
      };
    }
    this.chart.update(plotOptions, true);
    this.chart.reflow();
  }

  private initHighCharts(series: string) {
    const xAxis = {
      categories: [
        this.translate.instant(
          'i18n.cockpit.card.chart.lohnverteilung.quartil4'
        ),
        this.translate.instant(
          'i18n.cockpit.card.chart.lohnverteilung.quartil3'
        ),
        this.translate.instant(
          'i18n.cockpit.card.chart.lohnverteilung.quartil2'
        ),
        this.translate.instant(
          'i18n.cockpit.card.chart.lohnverteilung.quartil1'
        ),
        this.translate.instant('i18n.common.total')
      ]
    };
    const chartTitle = {
      text: this.translate.instant(
        'i18n.cockpit.card.chart.lohnverteilung.title'
      ),
      style: {color: '#333333', fontSize: '16px'}
    };
    const yAxis = {
      labelsFormat: '{value}%',
      min: 0,
      max: 100,
      tickInterval: null,
      titleText: ''
    };
    const legend = {reversed: true};
    const tooltip = {
      pointFormat:
        '<span style="color:{series.color}">{series.name}</span>: <span style="font-weight:bold;">{point.y}%</span><br/>',
      valueDecimals: 1
    };

    this.chartTemplate.initializeChartValues(
      series,
      chartTitle,
      xAxis,
      yAxis,
      legend,
      'normal',
      tooltip
    );

    Highcharts.chart(
      'svgContainerChartDialogLohnverteilung',
      this.chartTemplate.json,
      thechart => {
        this.callBackFuncToNormalizeBarChart(thechart);

        // Observer pour détecter les changements de taille du conteneur
        const resizeObserver = new ResizeObserver(() => {
          if (this.chart) {
            this.chart.reflow();
          }
        });
        resizeObserver.observe(
          document.getElementById('svgContainerChartDialogLohnverteilung')
        );
      }
    );
  }

  private callBackFuncToNormalizeBarChart(chart: Highcharts.Chart) {
    this.chart = chart;
    this.chart.reflow();
  }
}
